/**
 * @prettier
 */
import { Currencies } from 'src/constants/Currency';
import type { CurrencyFormatVm } from 'src/types/CurrencyFormatVm';

export function formatAsNumberCurrency(number?: string | null, currencyFormat?: CurrencyFormatVm): string {
    if (!number) {
        return '';
    }
    if (!currencyFormat) {
        currencyFormat = {
            // Fallback to mexican formatting in case of error
            locale: 'MX',
            currency: Currencies.MXN,
            fractionDigits: 0,
        };
    }

    const fractionDigits = number.includes('.') ? 2 : currencyFormat.fractionDigits;
    return Intl.NumberFormat(currencyFormat.locale, {
        style: 'currency',
        currency: currencyFormat.currency,
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits,
    }).format(number as any); // TODO: Create a test that verifies that this it is still possible to format strings since flow seems to complain
}
